import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl + 'user/face_analyzer';

@Injectable({
  providedIn: 'root',
})
export class SkinFitService {
  constructor(private http: HttpClient) {}

  searchSkinFits(
    itemPerPage: number,
    currentPage: number = 1,
    searchQuery: string
  ) {
    return this.http
      .post(apiUrl + '/search', {
        item_per_page: itemPerPage,
        current_page: currentPage,
        search_query: searchQuery,
        sorts: [{ field: 'date', direction: 'desc' }],
      })
      .pipe(
        map((res: any) => {
          return res.data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getLatestSkinFit() {
    return this.http
      .get(apiUrl + '/latest')
      .pipe(
        map((res: any) => {
          return res.data;
        })
      )
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        })
      );
  }

  calibrateSkinFit(formData: FormData) {
    return this.http
      .post(apiUrl, formData)
      .pipe(
        map((res: any) => {
          this.handleSuccess(res.message);
        })
      )
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        })
      );
  }

  private handleError(errorRes: HttpErrorResponse) {
    return throwError(errorRes);
  }
  private handleSuccess(message: string) {}
}
